import React, { forwardRef } from 'react';
import { Paper as MuiPaper } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/
export interface PaperProps {
  /** CSS class name applied to the root element */
  className?: string;
  /** Shadow depth; corresponds to `dp` in the spec. Accepts values between 0 and 24 inclusive. */
  elevation?: number;
  /** If `true`, rounded corners are disabled */
  square?: boolean;
  /** Inline styles applied to the root element */
  style?: React.CSSProperties;
  /** The content of the component */
  children?: React.ReactNode;
}

const Paper = forwardRef<HTMLDivElement, PaperProps>(
  ({ className, elevation, square, style, children, ...restProps }, ref) => {
    if (!isEmpty(restProps)) {
      reportErrorInProductionOrThrow(
        `Unexpected props passed to Paper: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the PaperProps interface and to the component's signature.`,
        true
      );
    }

    return (
      <MuiPaper className={className} elevation={elevation} square={square} style={style} ref={ref} {...restProps}>
        {children}
      </MuiPaper>
    );
  }
);

Paper.displayName = 'Paper';

export default Paper;
